module.exports = __webpack_public_path__ + "static/media/pa.c4233854.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pa.svg
// module id = 2183
// module chunks = 0